<div>
  <div mat-dialog-title>
    {{ type === 'update' ? 'Event auslösen' : 'Event Details' }}
  </div>
  <div mat-dialog-content>
    <div *ngIf="type === 'update'">
      <mat-form-field class="w-full">
        <mat-label>Event</mat-label>
        <mat-select [(ngModel)]="event" required>
          <mat-option *ngFor="let event of events" [value]="event.type">{{event.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="w-full">
        <mat-label>ID</mat-label>
        <input matInput [(ngModel)]="id" />
      </mat-form-field>
    </div>
    <div *ngIf="type === 'view'" class="whitespace-pre-wrap">
      <span *ngIf="data.field == 'data'">{{ value | json }}</span>
      <span *ngIf="data.field != 'data'">{{ value }}</span>
    </div>
  </div>
  <div mat-dialog-actions>
    <button *ngIf="type === 'update'"
            mat-button color="primary"
            [disabled]="!event || loading"
            (click)="onOk()">
      <div *ngIf="loading"
           class="border-gray-300 h-5 w-5 animate-spin rounded-full border-2 border-t-black"></div>
      <span *ngIf="!loading">OK</span>
    </button>
    <button mat-button color="warn" (click)="onCancel()">{{'cancel' | translate}}</button>
  </div>
</div>
